// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.message.type.filter.enums.SatelliteConversationReadRepliedStatusTypeV2

export enum SatelliteConversationReadRepliedStatusTypeV2 {
  NOT_REPLIED_TO = 'NOT_REPLIED_TO',
  SHOW_ALL = 'SHOW_ALL',
  UNREAD = 'UNREAD',
}

export const SatelliteConversationReadRepliedStatusTypeV2_values = [
  SatelliteConversationReadRepliedStatusTypeV2.NOT_REPLIED_TO,
  SatelliteConversationReadRepliedStatusTypeV2.SHOW_ALL,
  SatelliteConversationReadRepliedStatusTypeV2.UNREAD,
] as const;
